var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.759,
    height: 7,
    viewBox: "0 0 15.759 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65104",
    "data-name": "Path 65104",
    d: "M35.367,47a.943.943,0,0,1-.525-.175l-7-5.25A.87.87,0,0,1,28.367,40h14a.87.87,0,0,1,.525,1.575l-7,5.25A.943.943,0,0,1,35.367,47Z",
    transform: "translate(-27.488 -40)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/dropDownIcon.de00e1f22f17f31cec60ebd58177a977.svg";
export { ForwardRef as ReactComponent };